export default __webpack_public_path__ + "static/sac3.inspirations-1efc1c993b1a2cb85a8079f20829e44f.jpg";